import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { VegWizardDataService } from 'src/app/veg-wizard/services/veg-wizard-data.service';
import { VegWizardStateMachineService } from 'src/app/veg-wizard/services/veg-wizard-state-machine.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivatePreNotificationAdviceGuard implements CanActivate {
  constructor(public vwds: VegWizardDataService, 
    public stateMachine: VegWizardStateMachineService, 
    public router: Router) {}

  canActivate() {
    return true;
  }
  
}
